import React, { FC } from "react"
import { FloatingRates } from "./FloatingRates"

export const AdminFloatingRates: FC = () => {
  return (
    <>
      <FloatingRates rateType={"AMOUNT"} />
      <FloatingRates rateType={"M_VAL"} />
    </>
  )
}
